import React from 'react';
import { get } from 'lodash';
import { Controller } from 'react-hook-form';

import TextFieldDefault, {
  TextFieldDefaultProps,
} from '../../Posts/Forms/TextFieldDefault/TextFieldDefault';

type TextFieldControllerProps = TextFieldDefaultProps & {
  control: any;
  errors: any;
  name: string;
  rules?: any;
  error?: boolean;
  helperText?: string;
};

function TextFieldController({
  control,
  errors,
  name,
  rules,
  error,
  helperText,
  ...props
}: TextFieldControllerProps) {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { ref, ...rest } }: any) => (
        <TextFieldDefault
          {...rest}
          inputRef={ref}
          error={error || !!get(errors, name)}
          helperText={helperText || get(errors, `${name}.message`)}
          {...props}
        />
      )}
    />
  );
}

export default TextFieldController;
